import React from 'react';
import {Colors, FontStyles} from "../constants";
import SignUpView from "./sign_up_view";
import * as firebase from "firebase";

class SignUp extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.createAccount);
        let currentUser = firebase.auth().currentUser;
        console.log(currentUser);
        let verify = false;
        if (currentUser != null) {
            verify = !currentUser.emailVerified;
            console.log(verify);
        }
        this.state = {
            email: '',
            password: '',
            rePassword: '',
            invalidPass: false,
            invalidMail: false,
            errorMsg: '',
        }
    }

    handleSubmit(ev) {
        const e = ev.nativeEvent;
        let email = e.target[0].value;
        if (!email.includes('@')) {
            email += '@micreate.eu';
        }
        const pass = e.target[1].value;
        const rePass = e.target[2].value;
        if (pass !== rePass) {
            this.setState({
                errorMsg: 'Passwords don\'t match',
                invalidMail: false,
                invalidPass: true
            });
            return;
        }
        firebase
            .auth()
            .createUserWithEmailAndPassword(email, pass)
            .then((user) => {
                if (user != null) {
                    firebase.auth().currentUser.sendEmailVerification();
                }
                if (this.props.onSignedUp != null)
                    this.props.onSignedUp(user);
            })
            .catch((error) => {
                console.log(error);
                let state = {
                    invalidMail: false,
                    invalidPass: false,
                    errorMsg: error.message,
                };
                switch (error.code) {
                    case 'auth/email-already-in-use':
                        state.invalidMail = true;
                        break;
                    case 'auth/weak-password':
                        state.invalidPass = true;
                        break;
                    default:
                        console.log(error.code);
                }
                this.setState(state);
            });
        this.setState({
            email: email,
            password: pass,
            rePassword: rePass
        });
    }

    render() {
        return (
            <SignUpView onSubmit={(e) => this.handleSubmit(e)} {...this.state} {...this.props}/>
        );
    }
}

export default SignUp;
